import classNames from 'classnames';
import { ReactNode } from 'react';
import {
  DefinitionList,
  DefinitionListProps,
} from 'components/definition-list';
import { DefinitionTerm } from 'components/definition-list/definition-term';
import { DefinitionDescription } from 'components/definition-list/definition-description';

import styles from './Field.module.scss';

interface Props extends DefinitionListProps {
  label: string;
  value?: ReactNode;
  truncate?: boolean;
}

export const Field = ({ label, value, truncate = false, ...rest }: Props) => {
  return (
    <DefinitionList className={styles.flexField} {...rest}>
      <DefinitionTerm className={styles.fieldLabel}>{label}</DefinitionTerm>
      <DefinitionDescription
        className={classNames(styles.fieldValue, {
          [styles.truncate]: truncate,
        })}
      >
        {value ?? <>&mdash;</>}
      </DefinitionDescription>
    </DefinitionList>
  );
};
